import { Paragraph2 } from "@bounce/design-system"

import type { PoiData } from "@/libs/bounce/types"

import WalkIcon from "@bounce/assets/icons/Walk.svg"

const MAX_WALKING_TIME_MINUTES = 30

type StoreSliderCardPoiItemProps = Pick<PoiData, "translatedName"> & {
  walkingTime: string
  walkingTimeInMinutes: number
}

export const StoreSliderCardPoiItem = ({
  translatedName,
  walkingTime,
  walkingTimeInMinutes,
}: StoreSliderCardPoiItemProps) => {
  return walkingTimeInMinutes < MAX_WALKING_TIME_MINUTES ? (
    <li className="flex w-full items-center justify-between text-neutral-800">
      <Paragraph2 className="line-clamp-1 overflow-hidden text-ellipsis">{translatedName}</Paragraph2>
      <div className="flex shrink-0 items-center gap-1">
        <WalkIcon className="size-4" />
        <Paragraph2>{walkingTime}</Paragraph2>
      </div>
    </li>
  ) : null
}
